import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "sim-card-list" }
const _hoisted_2 = { class: "search-section" }
const _hoisted_3 = { class: "search-header" }
const _hoisted_4 = { class: "search-form" }
const _hoisted_5 = { class: "tabs-section" }
const _hoisted_6 = { class: "tabs-header" }
const _hoisted_7 = {
  key: 0,
  class: "tabs-actions"
}
const _hoisted_8 = {
  key: 0,
  class: "list-section"
}
const _hoisted_9 = { class: "pagination-section" }
const _hoisted_10 = {
  key: 1,
  class: "list-section"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "diagnosis-result" }

import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import apiClient from "@/services/apiClient";
import { API_URLS } from "@/config";
import { useStore } from "vuex";
import SimCardDetail from "./SimCardDetail.vue";

// 路由
interface SimCard {
  msisdn: string;
  billingGroup: string;
  iccid: string;
  imsi: string;
  operator: string;
  package: string;
  status: string;
  activationDate: string;
  expirationDate: string;
  currentUsage: string;
  usagePercentage: number;
  overLimitMB: number;
  billingGroupStats?: string;
}

interface SearchForm {
  msisdn: string;
  iccid: string;
  imsi: string;
  billingGroup: string;
  operator: string;
  overPackage: string;
}

// 响应式数据

export default /*@__PURE__*/_defineComponent({
  __name: 'SimCardList',
  setup(__props) {

const {
  Refresh,
  Search,
  Plus,
  Download,
  Operation,
  Document,
  Setting,
  ArrowDown,
  ArrowUp,
} = ElementPlusIconsVue as any;
const router = useRouter();
const store = useStore();

// 检查是否为超级管理员
const isSuperAdmin = computed(() => {
  return store.state.user?.role === "super_admin";
});

// 类型定义
const loading = ref(false);
const showSearchForm = ref(false);
const activeTab = ref("all");
const currentPage = ref(1);
const pageSize = ref(10);
const totalCards = ref(0);
const overLimitCount = ref(0);
const expiringCount = ref(0);
const simCards = ref<SimCard[]>([]);
const selectedCards = ref<SimCard[]>([]);
const diagnosisDialogVisible = ref(false);
const selectedCard = ref<SimCard | null>(null);
const diagnosisResult = ref<any>(null);
const billingGroups = ref<any[]>([]);
const simTableRef = ref<any>(null);

// 搜索表单
const searchForm = ref<any>({
  imsi: "",
});

// 方法
const fetchBillingGroups = async () => {
  try {
    const response = await apiClient.get(API_URLS.SIM_CARDS_BILLING_GROUPS);

    if (response.data.code === 0) {
      billingGroups.value = response.data.data.billingGroups || [];
    }
  } catch (error) {
    console.error("获取计费组数据失败:", error);
  }
};

const fetchSimCards = async () => {
  try {
    loading.value = true;
    const params: any = {
      page: currentPage.value,
      size: pageSize.value,
      imsi: searchForm.value.imsi || undefined,
    };

    // 如果在超限卡标签，增加过滤
    if (activeTab.value === "overLimit") {
      params.over_package = "1";
    }

    const response = await apiClient.get(API_URLS.SIM_CARDS_LIST, { params });

    if (response.data.code === 0) {
      const data = response.data.data;
      simCards.value = data.simCards || [];
      totalCards.value = data.total || 0;
    } else {
      ElMessage.error(response.data.message || "获取SIM卡列表失败");
    }
  } catch (error) {
    console.error("获取SIM卡列表失败:", error);
    ElMessage.error("获取SIM卡列表失败");
  } finally {
    loading.value = false;
  }
};

const fetchPoolStats = async () => {
  try {
    loading.value = true;
    const response = await apiClient.get(API_URLS.SIM_CARDS_BILLING_GROUPS);
    if (response.data.code === 0) {
      billingGroups.value = response.data.data.billingGroups || [];
    }
  } catch (error) {
    console.error("获取流量池统计失败:", error);
  } finally {
    loading.value = false;
  }
};

const handleTabChange = (name: any) => {
  const tabName = typeof name === "string" ? name : name.props.name;
  activeTab.value = tabName;
  currentPage.value = 1;
  if (tabName === "poolStats") {
    fetchPoolStats();
  } else {
    fetchSimCards();
  }
};

const handleSearch = () => {
  currentPage.value = 1;
  fetchSimCards();
};

const handleReset = () => {
  searchForm.value = {
    imsi: "",
  };
  currentPage.value = 1;
  fetchSimCards();
};

const goToDevice = (imsi: string) => {
  router.push({
    path: "/deviceManagement",
    query: { imsi },
  });
};

const toggleRowExpansion = (row: any) => {
  if (simTableRef.value) {
    simTableRef.value.toggleRowExpansion(row);
  }
};

const handleSizeChange = (size: number) => {
  pageSize.value = size;
  currentPage.value = 1;
  fetchSimCards();
};

const handleCurrentChange = (page: number) => {
  currentPage.value = page;
  fetchSimCards();
};

const handleSelectionChange = (selection: SimCard[]) => {
  selectedCards.value = selection;
};

const handleDiagnosis = async (card: SimCard) => {
  selectedCard.value = card;
  diagnosisDialogVisible.value = true;

  try {
    // 这里可以调用诊断API
    diagnosisResult.value = {
      title: "诊断完成",
      type: "success",
      description: "SIM卡状态正常，网络连接良好",
    };
  } catch (error) {
    diagnosisResult.value = {
      title: "诊断失败",
      type: "error",
      description: "无法连接到诊断服务",
    };
  }
};

const handleExport = async () => {
  try {
    ElMessage.info("导出功能开发中...");
  } catch (error) {
    ElMessage.error("导出失败");
  }
};

const handleBatchOperation = async () => {
  if (selectedCards.value.length === 0) {
    ElMessage.warning("请先选择要操作的SIM卡");
    return;
  }

  try {
    await ElMessageBox.confirm(
      `确定要对选中的 ${selectedCards.value.length} 张SIM卡进行批量操作吗？`,
      "批量操作",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    );

    ElMessage.info("批量操作功能开发中...");
  } catch (error) {
    // 用户取消
  }
};

const handleAdvancedExport = () => {
  ElMessage.info("高级导出功能开发中...");
};

const handleSettings = () => {
  ElMessage.info("设置功能开发中...");
};

const toggleSearchForm = () => {
  showSearchForm.value = !showSearchForm.value;
};

const getStatusType = (
  status: string
): "success" | "primary" | "danger" | "warning" | "info" => {
  const statusMap: Record<
    string,
    "success" | "primary" | "danger" | "warning" | "info"
  > = {
    正常: "success",
    测试期: "primary",
    停机: "danger",
    沉默期: "warning",
  };
  return statusMap[status] || "info";
};

const refreshData = () => {
  fetchSimCards();
};

const handleBillingGroupChange = (card: SimCard) => {
  // 处理计费组统计变化
  console.log("计费组统计变化:", card.iccid, card.billingGroupStats);
  ElMessage.info(`已更新 ${card.iccid} 的计费组统计`);
};

const goToSimCardStats = () => {
  router.push("/simCardStats");
};

// 生命周期
onMounted(() => {
  fetchBillingGroups();
  fetchSimCards();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_card, null, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("span", null, "搜索条件", -1)),
            _createVNode(_component_el_button, {
              link: "",
              onClick: toggleSearchForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(showSearchForm.value ? "收起" : "展开") + " ", 1),
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    (!showSearchForm.value)
                      ? (_openBlock(), _createBlock(_unref(ArrowDown), { key: 0 }))
                      : (_openBlock(), _createBlock(_unref(ArrowUp), { key: 1 }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "IMSI" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: searchForm.value.imsi,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.value.imsi) = $event)),
                          placeholder: "请输入完整卡号",
                          clearable: "",
                          onKeyup: _withKeys(handleSearch, ["enter"])
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: handleSearch,
                          loading: loading.value
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Search))
                              ]),
                              _: 1
                            }),
                            _cache[6] || (_cache[6] = _createTextVNode(" 查询 ", -1))
                          ]),
                          _: 1
                        }, 8, ["loading"]),
                        _createVNode(_component_el_button, { onClick: handleReset }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Refresh))
                              ]),
                              _: 1
                            }),
                            _cache[7] || (_cache[7] = _createTextVNode(" 重置 ", -1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, showSearchForm.value]
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_tabs, {
              modelValue: activeTab.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event)),
              onTabChange: handleTabChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "所有卡",
                  name: "all"
                }, {
                  label: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode(" 所有卡 ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "超限卡",
                  name: "overLimit"
                }, {
                  label: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" 超限卡 ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "流量池统计",
                  name: "poolStats"
                }, {
                  label: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode(" 流量池统计 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (isSuperAdmin.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: handleExport
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Download))
                        ]),
                        _: 1
                      }),
                      _cache[11] || (_cache[11] = _createTextVNode(" 导出数据 ", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, { onClick: handleBatchOperation }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Operation))
                        ]),
                        _: 1
                      }),
                      _cache[12] || (_cache[12] = _createTextVNode(" 批量操作 ", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, { onClick: handleAdvancedExport }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Document))
                        ]),
                        _: 1
                      }),
                      _cache[13] || (_cache[13] = _createTextVNode(" 高级导出 ", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, { onClick: handleSettings }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Setting))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    (activeTab.value !== 'poolStats')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _withDirectives((_openBlock(), _createBlock(_component_el_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_table, {
                ref_key: "simTableRef",
                ref: simTableRef,
                data: simCards.value,
                stripe: "",
                style: {"width":"100%"},
                onSelectionChange: handleSelectionChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, { type: "expand" }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(SimCardDetail, {
                        "card-id": row.iccid || row.imsi
                      }, null, 8, ["card-id"])
                    ]),
                    _: 1
                  }),
                  (isSuperAdmin.value)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        type: "selection",
                        width: "55"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_table_column, {
                    label: "单卡详情",
                    width: "120"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_button, {
                        link: "",
                        type: "primary",
                        onClick: ($event: any) => (toggleRowExpansion(row))
                      }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode(" 点击展开 ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "imsi",
                    label: "IMSI",
                    width: "180"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_link, {
                        type: "primary",
                        onClick: ($event: any) => (goToDevice(row.imsi))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.imsi), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "iccid",
                    label: "ICCID",
                    width: "200"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "operator",
                    label: "运营商",
                    width: "100"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "package",
                    label: "套餐",
                    width: "150"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "status",
                    label: "卡状态",
                    width: "100"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_tag, {
                        type: getStatusType(row.status),
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.status), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "activationDate",
                    label: "激活日期",
                    width: "120"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "expirationDate",
                    label: "到期日期",
                    width: "120"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "currentUsage",
                    label: "用量",
                    width: "180"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(row.currentUsage), 1),
                      _createVNode(_component_el_progress, {
                        percentage: row.usagePercentage,
                        status: row.usagePercentage > 90 ? 'exception' : ''
                      }, null, 8, ["percentage", "status"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_pagination, {
                  "current-page": currentPage.value,
                  "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((currentPage).value = $event)),
                  "page-size": pageSize.value,
                  "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageSize).value = $event)),
                  "page-sizes": [10, 20, 50, 100],
                  total: totalCards.value,
                  layout: "total, sizes, prev, pager, next, jumper",
                  onSizeChange: handleSizeChange,
                  onCurrentChange: handleCurrentChange
                }, null, 8, ["current-page", "page-size", "total"])
              ])
            ]),
            _: 1
          })), [
            [_directive_loading, loading.value]
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _withDirectives((_openBlock(), _createBlock(_component_el_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_table, {
                data: billingGroups.value,
                stripe: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "code",
                    label: "计费组代码",
                    width: "200"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "名称",
                    width: "200"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "trafficPoolName",
                    label: "流量池",
                    width: "200"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "billingMode",
                    label: "计费模式",
                    width: "100"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "availableCards",
                    label: "可用卡数",
                    width: "100"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "activatedCards",
                    label: "激活卡数",
                    width: "100"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "totalTrafficMB",
                    label: "总流量(MB)",
                    width: "150"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "usedTrafficMB",
                    label: "已用流量(MB)",
                    width: "150"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "使用率",
                    width: "150"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_progress, {
                        percentage: row.usedTrafficPercentage
                      }, null, 8, ["percentage"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _: 1
          })), [
            [_directive_loading, loading.value]
          ])
        ])),
    _createVNode(_component_el_dialog, {
      modelValue: diagnosisDialogVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((diagnosisDialogVisible).value = $event)),
      title: "SIM卡诊断",
      width: "600px"
    }, {
      default: _withCtx(() => [
        (selectedCard.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_el_descriptions, {
                column: 2,
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "ICCID" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedCard.value.iccid), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "MSISDN" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedCard.value.msisdn), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "运营商" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedCard.value.operator), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "状态" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedCard.value.status), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "套餐" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedCard.value.package), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "流量使用" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedCard.value.currentUsage), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_12, [
                _cache[15] || (_cache[15] = _createElementVNode("h4", null, "诊断结果", -1)),
                (diagnosisResult.value)
                  ? (_openBlock(), _createBlock(_component_el_alert, {
                      key: 0,
                      title: diagnosisResult.value.title,
                      type: diagnosisResult.value.type,
                      description: diagnosisResult.value.description,
                      "show-icon": ""
                    }, null, 8, ["title", "type", "description"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})